export default __webpack_public_path__ + "static/media/my-recipes.19b9c82c.png";